/* ===== Client interface template styles (preview + persisted) ===== */
import { sanitizeImageSrc } from '../utils/url.js?v=83.21';
import { getCurrentSettings } from '../services/settings.js?v=83.21';
import {
  registerClientTemplate,
  restoreAllClientTemplates,
  applyClientTemplateDom
} from './client-template-registry.js?v=83.21';

export const CLIENT_TEMPLATE_STYLES = ['elegant', 'modern', 'dynamic', 'future', 'minimal', 'connect', 'alfa', 'custom', 'avva', 'afis', 'tabla', 'glass', 'cloud', 'cloud-light', 'rimga', 'ai-generated'];
export const CLIENT_TEMPLATE_FIXED = ['elegant', 'modern', 'dynamic', 'future', 'minimal'];
/** Temele oferite în picker și de „Alege pentru mine”. */
export const CLIENT_TEMPLATE_PICKABLE = ['cloud', 'cloud-light', 'rimga', 'avva', 'afis', 'tabla', 'glass', 'custom'];

/** Teme scoase din listă → înlocuitorul afișat (conturile care le aveau salvate nu se strică). */
export const RETIRED_TEMPLATE_MAP = {
  standard: 'cloud',
  connect: 'cloud',
  alfa: 'avva',
  elegant: 'cloud',
  modern: 'cloud-light',
  dynamic: 'cloud',
  future: 'cloud-light',
  minimal: 'cloud',
  'ai-generated': 'cloud'
};
export const DEFAULT_CLIENT_TEMPLATE_STYLE = 'cloud';

/**
 * Etichete V2 pe obiectiv (ID-urile tehnice rămân neschimbate).
 * Mapare: alfa→Universal, minimal→Essentials, dynamic→Campaign Focus,
 * future→Loyalty Focus, elegant→Reviews Focus, connect→Social Boost,
 * modern→Offers Focus. Avva = Universal Soft (aceeași familie, variantă light).
 */
export const CLIENT_TEMPLATE_LABELS = {
  standard: 'Standard',
  elegant: 'Reviews Focus',
  modern: 'Offers Focus',
  dynamic: 'Campaign Focus',
  future: 'Loyalty Focus',
  minimal: 'Essentials',
  connect: 'Social Boost',
  alfa: 'Universal',
  custom: 'Custom',
  avva: 'Universal Soft',
  afis: 'Afiș',
  tabla: 'Tablă',
  glass: 'Glass',
  cloud: 'Cloud Dark',
  'cloud-light': 'Cloud Luminos',
  rimga: 'Rimga',
  'ai-generated': 'Alege pentru mine'
};

/** Custom + Universal Soft — disponibile pe toate mediile (prod, staging, localhost). */
export function isCustomTemplateAvailable() {
  return true;
}

export const CLIENT_HEADER_SOCIAL_SVGS = {
  facebook:
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>',
  instagram:
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.248 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.272 2.695.272.273 2.69.073 7.052.214 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>',
  tiktok:
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>'
};

export function normalizeClientTemplateStyle(raw) {
  const id0 = String(raw || '').trim().toLowerCase();
  const id = RETIRED_TEMPLATE_MAP[id0] || id0;
  if ((id === 'custom' || id === 'avva') && !isCustomTemplateAvailable()) return DEFAULT_CLIENT_TEMPLATE_STYLE;
  return CLIENT_TEMPLATE_STYLES.includes(id) ? id : DEFAULT_CLIENT_TEMPLATE_STYLE;
}

/** Doar pe staging / localhost: ?sjTheme=rimga previzualizează o temă pe pagina publică (pentru teste). */
function previewThemeOverride() {
  try {
    const h = window.location.hostname;
    if (!(h === 'localhost' || h === '127.0.0.1' || h.startsWith('spressjoy-staging'))) return '';
    const t = new URLSearchParams(window.location.search).get('sjTheme');
    return t && CLIENT_TEMPLATE_STYLES.includes(t) ? t : '';
  } catch (_) {
    return '';
  }
}

export function getClientTemplateStyleFromSettings(settings) {
  return normalizeClientTemplateStyle(previewThemeOverride() || settings?.clientTemplateStyle);
}

export function isStandardTemplateFromSettings(settings) {
  return getClientTemplateStyleFromSettings(settings) === 'standard';
}

export function isElegantTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-elegant');
}

export function isModernTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-modern');
}

export function isDynamicTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-dynamic');
}

export function isFutureTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-future');
}

export function isMinimalTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-minimal');
}

export function isConnectTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-connect');
}

export function isAlfaTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-alfa');
}

export function isCustomTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-custom');
}

export function isAvvaTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-avva');
}

export function isAfisTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-afis');
}

export function isTablaTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-tabla');
}

export function isGlassTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-glass');
}

/** Afiș, Tablă sau Glass — aceeași structură de blocuri (client-afis-template.js), CSS diferit. */
export function isPosterTemplateActive(page = document.getElementById('clientPage')) {
  return isAfisTemplateActive(page) || isTablaTemplateActive(page) || isGlassTemplateActive(page);
}

export function isStandardTemplateActive(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-standard');
}

const STANDARD_TEMPLATE_CLASS_MARKERS = [
  'template-elegant',
  'template-modern',
  'template-dynamic',
  'template-future',
  'template-minimal',
  'template-connect',
  'template-alfa',
  'template-custom',
  'template-avva',
  'template-afis',
  'template-tabla',
  'template-glass',
  'template-cloud',
  'template-cloud-light',
  'template-cloud-rimga',
  'template-ai-generated'
];

/** Standard activ — clasă dedicată sau lipsă alt template (fallback). */
export function isStandardVisualActive(page = document.getElementById('clientPage')) {
  if (!page) return true;
  if (page.classList.contains('template-standard')) return true;
  return !STANDARD_TEMPLATE_CLASS_MARKERS.some((c) => page.classList.contains(c));
}

export function isAiPreviewStandardPending() {
  return (
    typeof window !== 'undefined' &&
    window.__aiLayoutPreviewActive === true &&
    String(window.__aiTemplatePendingStyle || '').trim().toLowerCase() === 'standard'
  );
}

/** În preview AI folosește tema aleasă din picker, nu ce e salvată în Firestore. */
export function getActiveClientTemplateStyleForUi(settings = getCurrentSettings()) {
  // Joy Assistant: pagina se construiește live pe designul Custom
  if (
    typeof document !== 'undefined' &&
    document.body?.classList.contains('joy-assistant-client-preview') &&
    isCustomTemplateAvailable()
  ) {
    return 'custom';
  }
  if (typeof window !== 'undefined' && window.__aiLayoutPreviewActive === true) {
    const pending = String(window.__aiTemplatePendingStyle || '').trim().toLowerCase();
    if (pending) {
      if ((pending === 'custom' || pending === 'avva') && !isCustomTemplateAvailable()) {
        return getClientTemplateStyleFromSettings(settings);
      }
      return normalizeClientTemplateStyle(pending);
    }
  }
  return getClientTemplateStyleFromSettings(settings);
}

function isPromoCarouselTemplateActive(page = document.getElementById('clientPage')) {
  return isDynamicTemplateActive(page);
}

function restoreFutureTopRow() {
  const row = document.getElementById('clientFutureTopRow');
  if (!row) return;

  const promo = document.getElementById('clientPremiumSectionPromo');
  const social = document.getElementById('clientElegantSocialSection');
  const hero = document.getElementById('clientHeroActions');

  if (promo && hero && promo.parentNode === row) {
    row.removeChild(promo);
    hero.insertBefore(promo, row.firstChild || null);
  }
  if (social && hero && social.parentNode === row) {
    row.removeChild(social);
    if (promo && promo.parentNode === hero) {
      hero.insertBefore(social, promo.nextSibling);
    } else {
      hero.appendChild(social);
    }
  }
  row.remove();
}

function restoreFutureHeroSpacer() {
  document.getElementById('clientFutureHeroSpacer')?.remove();
}

function restoreFutureHeaderSocialCol() {
  const col = document.getElementById('clientFutureHeaderSocialCol');
  const socialRow = document.getElementById('clientTemplateSocialRow');
  const top = document.querySelector('#clientTemplateHeader .client-template-header__top');
  if (col && socialRow && top && socialRow.parentNode === col) {
    top.appendChild(socialRow);
  }
  document.getElementById('clientFutureSocialHint')?.remove();
  col?.remove();
}

function ensureFutureHeaderSocialCol() {
  const header = document.getElementById('clientTemplateHeader');
  const socialRow = document.getElementById('clientTemplateSocialRow');
  const top = header?.querySelector('.client-template-header__top');
  if (!header || !socialRow || !top) return;

  let col = document.getElementById('clientFutureHeaderSocialCol');
  if (!col) {
    col = document.createElement('div');
    col.id = 'clientFutureHeaderSocialCol';
    col.className = 'client-future-header-social-col';
    top.appendChild(col);
  }

  if (socialRow.parentNode !== col) col.appendChild(socialRow);

  let hint = document.getElementById('clientFutureSocialHint');
  if (!hint) {
    hint = document.createElement('p');
    hint.id = 'clientFutureSocialHint';
    hint.className = 'client-future-social-hint';
    col.appendChild(hint);
  } else if (hint.parentNode !== col) {
    col.appendChild(hint);
  }
}

function ensureFuturePromoStandalone() {
  restoreFutureTopRow();

  const hero = document.getElementById('clientHeroActions');
  const promo = document.getElementById('clientPremiumSectionPromo');
  if (!hero || !promo) return;

  if (promo.parentNode !== hero) {
    hero.insertBefore(promo, hero.firstChild || null);
  }
}

function ensureFutureHeroSpacer() {
  const page = document.getElementById('clientPage');
  const cta = document.getElementById('clientPremiumCenterCta');
  if (!page || !cta) return;

  let spacer = document.getElementById('clientFutureHeroSpacer');
  if (!spacer) {
    spacer = document.createElement('div');
    spacer.id = 'clientFutureHeroSpacer';
    spacer.className = 'client-future-hero-spacer';
    spacer.setAttribute('aria-hidden', 'true');
  }
  if (spacer.parentNode !== page) {
    page.insertBefore(spacer, cta);
  }
}

export function syncFutureSocialStrip(settings = {}) {
  const section = document.getElementById('clientElegantSocialSection');
  const elegantRow = document.getElementById('clientElegantSocialRow');
  const socialRow = document.getElementById('clientTemplateSocialRow');
  const hint = document.getElementById('clientFutureSocialHint');

  if (section) {
    section.hidden = true;
    section.setAttribute('aria-hidden', 'true');
    section.style.display = 'none';
  }
  if (elegantRow) elegantRow.replaceChildren();

  if (!isFutureTemplateActive()) {
    restoreFutureHeaderSocialCol();
    if (socialRow) {
      socialRow.replaceChildren();
      socialRow.hidden = true;
      socialRow.setAttribute('aria-hidden', 'true');
    }
    return;
  }

  ensureFutureHeaderSocialCol();
  if (!socialRow) return;

  const platforms = getHeaderSocialPlatforms(settings);
  socialRow.replaceChildren();

  if (platforms.length === 0) {
    socialRow.hidden = true;
    socialRow.setAttribute('aria-hidden', 'true');
    if (hint) {
      hint.hidden = true;
      hint.setAttribute('hidden', '');
    }
    return;
  }

  platforms.forEach((platform) => {
    const item = document.createElement('button');
    item.type = 'button';
    item.className = `client-future-social-icon client-future-social-icon--${platform.key}`;
    item.setAttribute('data-action', 'openExternalAction');
    item.setAttribute('data-arg', platform.arg);
    item.setAttribute('aria-label', platform.label);
    item.innerHTML = CLIENT_HEADER_SOCIAL_SVGS[platform.key] || '';
    socialRow.appendChild(item);
  });

  socialRow.hidden = false;
  socialRow.removeAttribute('hidden');
  socialRow.removeAttribute('aria-hidden');

  if (hint) {
    hint.textContent =
      String(settings?.socialCardHint || '').trim() || 'Urmărește-ne pe social media';
    hint.hidden = false;
    hint.removeAttribute('hidden');
  }
}

function hexToRgbString(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(String(hex || '').trim());
  if (!m) return null;
  return `${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}`;
}

function sampleImageAccent(url) {
  return new Promise((resolve) => {
    const safe = sanitizeImageSrc(String(url || '').trim());
    if (!safe) {
      resolve(null);
      return;
    }
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        const size = 28;
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          resolve(null);
          return;
        }
        ctx.drawImage(img, 0, 0, size, size);
        const data = ctx.getImageData(0, 0, size, size).data;
        let r = 0;
        let g = 0;
        let b = 0;
        let n = 0;
        for (let i = 0; i < data.length; i += 4) {
          if (data[i + 3] < 120) continue;
          const pr = data[i];
          const pg = data[i + 1];
          const pb = data[i + 2];
          const lum = 0.299 * pr + 0.587 * pg + 0.114 * pb;
          if (lum < 35 || lum > 215) continue;
          r += pr;
          g += pg;
          b += pb;
          n += 1;
        }
        if (!n) {
          resolve(null);
          return;
        }
        const toHex = (v) => Math.round(v / n).toString(16).padStart(2, '0');
        resolve(`#${toHex(r)}${toHex(g)}${toHex(b)}`);
      } catch (_) {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = safe;
  });
}

export async function syncDynamicTemplateAccent(settings = {}) {
  const page = document.getElementById('clientPage');
  if (!isDynamicTemplateActive(page)) return;

  let accent = String(settings?.buttonColor || '#22c55e').trim();
  const logoUrl = settings?.locationLogoURL || '';
  const bgList = settings?.bgURLs || [];
  const bgUrl = bgList[0] || settings?.bgURL || '';

  const logoAccent = await sampleImageAccent(logoUrl);
  if (logoAccent) {
    accent = logoAccent;
  } else {
    const bgAccent = await sampleImageAccent(bgUrl);
    if (bgAccent) accent = bgAccent;
  }

  const rgb = hexToRgbString(accent);
  if (accent) page.style.setProperty('--tpl-dynamic-accent', accent);
  if (rgb) page.style.setProperty('--tpl-dynamic-accent-rgb', rgb);
}

function restoreDynamicPromoDomStructure() {
  const trigger = document.getElementById('clientPromoGalleryTrigger');
  if (!trigger) return;

  clearDynamicPromoPreview();

  const content = trigger.querySelector('.client-dynamic-promo-card__content');
  if (content) {
    while (content.firstChild) {
      trigger.insertBefore(content.firstChild, content);
    }
    content.remove();
  }

  document.getElementById('clientDynamicPromoPreview')?.remove();
  document.getElementById('clientDynamicPromoPreviewDots')?.remove();
  trigger.querySelector('.client-dynamic-promo-card__scrim')?.remove();

  trigger.classList.remove('client-dynamic-promo-card', 'client-dynamic-promo-card--has-images');
  delete trigger.dataset.dynamicPromoDom;
}

function applyDynamicPromoDomStructure() {
  const trigger = document.getElementById('clientPromoGalleryTrigger');
  if (!trigger || trigger.dataset.dynamicPromoDom === '1') return;

  trigger.classList.add('client-dynamic-promo-card');

  if (!document.getElementById('clientDynamicPromoPreview')) {
    const preview = document.createElement('div');
    preview.className = 'client-dynamic-promo-preview';
    preview.id = 'clientDynamicPromoPreview';
    preview.hidden = true;
    preview.setAttribute('aria-hidden', 'true');
    trigger.insertBefore(preview, trigger.firstChild);

    const dots = document.createElement('div');
    dots.className = 'client-dynamic-promo-preview-dots';
    dots.id = 'clientDynamicPromoPreviewDots';
    dots.hidden = true;
    dots.setAttribute('aria-hidden', 'true');
    trigger.insertBefore(dots, preview.nextSibling);

    const scrim = document.createElement('div');
    scrim.className = 'client-dynamic-promo-card__scrim';
    scrim.setAttribute('aria-hidden', 'true');
    trigger.insertBefore(scrim, dots.nextSibling);
  }

  if (!trigger.querySelector('.client-dynamic-promo-card__content')) {
    const content = document.createElement('div');
    content.className = 'client-dynamic-promo-card__content';
    const movable = [...trigger.children].filter(
      (el) =>
        !el.classList.contains('client-dynamic-promo-preview') &&
        !el.classList.contains('client-dynamic-promo-preview-dots') &&
        !el.classList.contains('client-dynamic-promo-card__scrim')
    );
    content.append(...movable);
    trigger.appendChild(content);
  }

  trigger.dataset.dynamicPromoDom = '1';
}

let dynamicPromoSlideshowTimer = null;

function clearDynamicPromoPreview() {
  if (dynamicPromoSlideshowTimer) {
    window.clearInterval(dynamicPromoSlideshowTimer);
    dynamicPromoSlideshowTimer = null;
  }
  const preview = document.getElementById('clientDynamicPromoPreview');
  const dots = document.getElementById('clientDynamicPromoPreviewDots');
  const trigger = document.getElementById('clientPromoGalleryTrigger');
  if (preview) {
    preview.replaceChildren();
    preview.hidden = true;
  }
  if (dots) {
    dots.replaceChildren();
    dots.hidden = true;
  }
  if (trigger) trigger.classList.remove('client-dynamic-promo-card--has-images');
}

export function syncDynamicPromoPreview(settings = {}) {
  if (!isPromoCarouselTemplateActive()) {
    clearDynamicPromoPreview();
    return;
  }

  const g = settings?.clientPromoGallery;
  const images = (g?.enabled === true && Array.isArray(g?.images) ? g.images : [])
    .map((u) => sanitizeImageSrc(String(u || '').trim()))
    .filter(Boolean)
    .slice(0, 10);

  const preview = document.getElementById('clientDynamicPromoPreview');
  const dotsEl = document.getElementById('clientDynamicPromoPreviewDots');
  const trigger = document.getElementById('clientPromoGalleryTrigger');
  if (!preview || !trigger) return;

  clearDynamicPromoPreview();

  if (!images.length) {
    return;
  }

  trigger.classList.add('client-dynamic-promo-card--has-images');
  preview.hidden = false;
  preview.removeAttribute('hidden');

  const slides = images.map((url, i) => {
    const slide = document.createElement('div');
    slide.className = `client-dynamic-promo-preview__slide${i === 0 ? ' is-active' : ''}`;
    const img = document.createElement('img');
    img.src = url;
    img.alt = '';
    img.decoding = 'async';
    img.loading = 'eager';
    slide.appendChild(img);
    preview.appendChild(slide);
    return slide;
  });

  if (images.length > 1 && dotsEl) {
    dotsEl.hidden = false;
    dotsEl.removeAttribute('hidden');
    const dotButtons = images.map((_, i) => {
      const d = document.createElement('span');
      d.className = `client-dynamic-promo-preview__dot${i === 0 ? ' is-active' : ''}`;
      dotsEl.appendChild(d);
      return d;
    });

    let index = 0;
    const goTo = (i) => {
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach((s, j) => s.classList.toggle('is-active', j === index));
      dotButtons.forEach((d, j) => d.classList.toggle('is-active', j === index));
    };

    dynamicPromoSlideshowTimer = window.setInterval(() => goTo(index + 1), 4500);
  }
}

export function syncDynamicHeaderEditable(settings = {}) {
  const page = document.getElementById('clientPage');
  let existing = document.getElementById('clientTemplateEditable');
  if (!isDynamicTemplateActive(page)) {
    if (existing) {
      existing.hidden = true;
      existing.setAttribute('hidden', '');
    }
    page?.classList.remove('client-dynamic-header-promo');
    const promoSection = document.getElementById('clientPremiumSectionPromo');
    if (promoSection) {
      promoSection.hidden = false;
      promoSection.removeAttribute('hidden');
      promoSection.removeAttribute('aria-hidden');
    }
    return;
  }

  const header = document.getElementById('clientTemplateHeader');
  if (!header) return;

  if (existing && existing.tagName !== 'BUTTON') {
    existing.remove();
    existing = null;
  }

  let el = existing;
  if (!el) {
    el = document.createElement('button');
    el.type = 'button';
    el.id = 'clientTemplateEditable';
    el.className = 'client-template-header__editable';
    el.setAttribute('aria-haspopup', 'dialog');
    el.setAttribute('aria-controls', 'clientPromoGalleryOverlay');
    el.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      import('./client-promo-gallery.js?v=83.21')
        .then((m) => m.openClientPromoGalleryOverlay?.())
        .catch(() => {});
    });
    header.appendChild(el);
  }

  const g = settings?.clientPromoGallery;
  const enabled = g?.enabled === true;
  const text = String(g?.title || '').trim();

  const showHeaderPromo = enabled && !!text;
  const promoSection = document.getElementById('clientPremiumSectionPromo');

  if (showHeaderPromo) {
    el.textContent = text;
    el.hidden = false;
    el.removeAttribute('hidden');
    el.disabled = false;
    el.setAttribute('aria-label', text);
  } else {
    el.textContent = '';
    el.hidden = true;
    el.setAttribute('hidden', '');
    el.disabled = true;
    el.removeAttribute('aria-label');
  }

  page?.classList.toggle('client-dynamic-header-promo', showHeaderPromo);

  if (promoSection) {
    if (showHeaderPromo) {
      promoSection.hidden = true;
      promoSection.setAttribute('hidden', '');
      promoSection.setAttribute('aria-hidden', 'true');
    } else {
      promoSection.hidden = false;
      promoSection.removeAttribute('hidden');
      promoSection.removeAttribute('aria-hidden');
    }
  }
}

function applyDynamicHeaderOrder(isDynamic) {
  const header = document.getElementById('clientTemplateHeader');
  const top = header?.querySelector('.client-template-header__top');
  const sloganEl = document.getElementById('clientTemplateSlogan');
  const socialRow = document.getElementById('clientTemplateSocialRow');
  if (!header || !top || !sloganEl) return;

  if (isDynamic && socialRow) {
    if (sloganEl.parentElement !== top) {
      top.insertBefore(sloganEl, socialRow);
    } else if (sloganEl.nextElementSibling !== socialRow) {
      top.insertBefore(sloganEl, socialRow);
    }
    return;
  }

  if (sloganEl.parentElement === top) {
    header.insertBefore(sloganEl, top.nextSibling);
  }
}

export function syncDynamicCentralHero() {
  const page = document.getElementById('clientPage');
  if (!isDynamicTemplateActive(page)) return;

  const promoWrap = document.getElementById('layoutBlockPromo');
  const playBtn = document.getElementById('playBtn');
  const headerPromo = document.getElementById('clientTemplateEditable');
  const headerPromoOn =
    !!headerPromo &&
    !headerPromo.hidden &&
    String(headerPromo.textContent || '').trim().length > 0;

  const promoOn =
    headerPromoOn ||
    (!!promoWrap &&
      getComputedStyle(promoWrap).display !== 'none' &&
      promoWrap.getAttribute('aria-hidden') !== 'true');
  const campaignOn = !!playBtn && getComputedStyle(playBtn).display !== 'none';

  page.classList.remove('client-dynamic-hero-promo', 'client-dynamic-hero-campaign', 'client-dynamic-hero-both');

  if (campaignOn) {
    page.classList.add('client-dynamic-hero-campaign');
  } else if (promoOn) {
    page.classList.add('client-dynamic-hero-promo');
  }
}

export function syncDynamicClientCopy(settings = {}) {
  if (!isDynamicTemplateActive()) return;

  syncTemplateHeaderBrand(settings);

  const menuSub = document.getElementById('clientMenuCardSubtitle');
  if (menuSub) {
    menuSub.textContent =
      String(settings?.menuDescription || '').trim() || 'Vezi detalii';
  }

  const reviewSub = document.getElementById('clientReviewCardSubtitle');
  if (reviewSub) {
    reviewSub.textContent =
      String(settings?.feedbackSubtext || settings?.feedbackTitle || '').trim() ||
      'Vezi ce spun clienții despre noi';
  }

  const campaignSub = document.getElementById('clientCampaignSubtitle');
  if (campaignSub) {
    campaignSub.textContent =
      String(settings?.claimMessage || '').trim() || 'Joacă și câștigă premii!';
  }

  const promoSub = document.querySelector(
    '#clientPromoGalleryTrigger .client-premium-banner__subtitle'
  );
  if (promoSub) {
    promoSub.textContent =
      String(settings?.clientPromoGallery?.subtitle || '').trim() ||
      'Descoperă cele mai bune oferte';
  }

  syncDynamicHeaderEditable(settings);
  syncDynamicCentralHero();
}

const TEMPLATE_DOM_RESET_IDS = [
  'clientHeroActions',
  'clientPremiumStage',
  'clientPremiumCenterCta',
  'clientPremiumSectionPromo',
  'clientPremiumSectionDuo',
  'clientPremiumBottomDock',
  'layoutBlockMenu',
  'layoutBlockReview',
  'layoutBlockPromo',
  'layoutBlockCampaign',
  'layoutBlockRules',
  'layoutBlockSocial',
  'layoutBlockLoyalty',
  'layoutBlockEvent',
  'clientPromoGalleryTrigger',
  'clientPublicBrandLogo',
  'socialIconsBar'
];

export function restoreTemplateGlobalVisualState() {
  const bg = document.getElementById('bgContainer');
  if (bg) {
    bg.style.removeProperty('--tpl-future-bg-fade-start');
  }
  if (typeof document !== 'undefined') {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('height');
  }
  document.querySelectorAll('#bgContainer .bg-slide').forEach((slide) => {
    slide.style.removeProperty('background-position');
    delete slide.dataset.smartBgPos;
  });
}

export function restoreStandardClientCopy(settings = {}) {
  const menuSub = document.getElementById('clientMenuCardSubtitle');
  if (menuSub) {
    menuSub.textContent =
      String(settings?.menuDescription || '').trim() || 'Vezi detalii';
    menuSub.hidden = false;
    menuSub.removeAttribute('hidden');
    menuSub.style.removeProperty('display');
  }

  const reviewSub = document.getElementById('clientReviewCardSubtitle');
  if (reviewSub) {
    reviewSub.textContent =
      String(settings?.feedbackSubtext || settings?.feedbackTitle || '').trim() ||
      'Lasă-ne părerea ta';
    reviewSub.hidden = false;
    reviewSub.removeAttribute('hidden');
    reviewSub.style.removeProperty('display');
  }

  const campaignSub = document.getElementById('clientCampaignSubtitle');
  if (campaignSub) {
    campaignSub.textContent =
      String(settings?.claimMessage || '').trim() || 'Scanează bonul și primești puncte!';
    campaignSub.hidden = false;
    campaignSub.removeAttribute('hidden');
    campaignSub.style.removeProperty('display');
  }

  const promoSub = document.querySelector(
    '#clientPromoGalleryTrigger .client-premium-banner__subtitle'
  );
  if (promoSub) {
    promoSub.textContent =
      String(settings?.clientPromoGallery?.subtitle || '').trim() ||
      'Descoperă cele mai bune oferte';
    promoSub.hidden = false;
    promoSub.removeAttribute('hidden');
    promoSub.style.removeProperty('display');
  }
}

function resetTemplateDomElement(el) {
  if (!el) return;
  el.hidden = false;
  el.removeAttribute('hidden');
  el.removeAttribute('aria-hidden');
  clearTemplateDomInlineStyles(el);
}

function clearTemplateDomInlineStyles(el) {
  if (!el) return;
  [
    'display',
    'flex',
    'flex-direction',
    'align-items',
    'justify-content',
    'gap',
    'order',
    'min-height',
    'max-height',
    'height',
    'width',
    'min-width',
    'max-width',
    'padding',
    'padding-top',
    'padding-bottom',
    'padding-left',
    'padding-right',
    'margin',
    'position',
    'inset',
    'bottom',
    'left',
    'right',
    'top',
    'visibility',
    'opacity',
    'overflow',
    'pointer-events',
    'z-index',
    'transform',
    'grid-template-rows',
    'grid-template-columns'
  ].forEach((prop) => el.style.removeProperty(prop));
}

const STANDARD_DOM_UNHIDE_IDS = [
  'clientHeroActions',
  'clientPremiumStage',
  'clientPremiumCenterCta',
  'clientPremiumSectionPromo',
  'clientPremiumSectionDuo',
  'clientPremiumBottomDock',
  'layoutBlockMenu',
  'layoutBlockReview',
  'layoutBlockPromo',
  'layoutBlockCampaign',
  'layoutBlockRules',
  'layoutBlockSocial',
  'layoutBlockLoyalty',
  'layoutBlockEvent',
  'clientPromoGalleryTrigger',
  'socialIconsBar'
];

/** Reafișează DOM-ul clasic Standard (fără clase template-*). */
export function applyStandardTemplateDomFixes(settings = {}) {
  STANDARD_DOM_UNHIDE_IDS.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
    el.removeAttribute('aria-hidden');
    clearTemplateDomInlineStyles(el);
  });

  const header = document.getElementById('clientTemplateHeader');
  if (header) {
    header.classList.remove('client-elegant-top-chrome');
    header.hidden = true;
    header.setAttribute('aria-hidden', 'true');
    clearTemplateDomInlineStyles(header);
  }

  const logoEl = document.getElementById('clientTemplateBrandLogo');
  if (logoEl) logoEl.classList.remove('client-elegant-top-chrome__logo-ph');

  const sloganEl = document.getElementById('clientTemplateSlogan');
  if (sloganEl) {
    sloganEl.textContent = '';
    sloganEl.hidden = true;
    sloganEl.setAttribute('hidden', '');
    clearTemplateDomInlineStyles(sloganEl);
  }

  const connectHint = document.getElementById('clientConnectSocialHint');
  if (connectHint) {
    connectHint.textContent = '';
    connectHint.hidden = true;
    connectHint.setAttribute('hidden', '');
    connectHint.setAttribute('aria-hidden', 'true');
    clearTemplateDomInlineStyles(connectHint);
  }

  const elegantSocial = document.getElementById('clientElegantSocialSection');
  if (elegantSocial) {
    elegantSocial.hidden = true;
    elegantSocial.setAttribute('aria-hidden', 'true');
    elegantSocial.style.setProperty('display', 'none', 'important');
    clearTemplateDomInlineStyles(elegantSocial);
  }

  const menuBody = document.querySelector('#layoutBlockMenu .client-premium-menu__body');
  if (menuBody) menuBody.style.removeProperty('display');

  const editable = document.getElementById('clientTemplateEditable');
  if (editable) {
    editable.hidden = true;
    editable.setAttribute('hidden', '');
    editable.textContent = '';
  }

  applyDynamicHeaderOrder(false);
  restoreStandardReviewCardMarkup();
  restoreStandardClientCopy(settings);
  syncCompactReviewCard(settings);
  syncDynamicHeaderEditable(settings);
}

/** Undo all template-specific inline DOM — call before applying any template. */
export function restoreAllTemplateDomState() {
  restoreFutureTopRow();
  restoreFutureHeaderSocialCol();
  restoreFutureHeroSpacer();
  restoreDynamicPromoDomStructure();
  clearDynamicPromoPreview();
  restoreStandardReviewCardMarkup();
  restoreTemplateGlobalVisualState();

  TEMPLATE_DOM_RESET_IDS.forEach((id) => {
    resetTemplateDomElement(document.getElementById(id));
  });

  const header = document.getElementById('clientTemplateHeader');
  if (header) {
    header.classList.remove('client-elegant-top-chrome');
    header.hidden = true;
    header.setAttribute('aria-hidden', 'true');
    clearTemplateDomInlineStyles(header);
  }

  const sloganEl = document.getElementById('clientTemplateSlogan');
  if (sloganEl) {
    sloganEl.textContent = '';
    sloganEl.hidden = true;
    sloganEl.setAttribute('hidden', '');
    clearTemplateDomInlineStyles(sloganEl);
  }

  const connectHint = document.getElementById('clientConnectSocialHint');
  if (connectHint) {
    connectHint.textContent = '';
    connectHint.hidden = true;
    connectHint.setAttribute('hidden', '');
    connectHint.setAttribute('aria-hidden', 'true');
    clearTemplateDomInlineStyles(connectHint);
  }

  const elegantSocial = document.getElementById('clientElegantSocialSection');
  if (elegantSocial) {
    elegantSocial.hidden = true;
    elegantSocial.setAttribute('aria-hidden', 'true');
    elegantSocial.style.setProperty('display', 'none', 'important');
    clearTemplateDomInlineStyles(elegantSocial);
  }

  applyDynamicHeaderOrder(false);

  const logoEl = document.getElementById('clientTemplateBrandLogo');
  if (logoEl) logoEl.classList.remove('client-elegant-top-chrome__logo-ph');

  const socialRow = document.getElementById('clientTemplateSocialRow');
  if (socialRow) {
    socialRow.hidden = true;
    socialRow.setAttribute('aria-hidden', 'true');
    socialRow.replaceChildren();
  }

  const menuBody = document.querySelector('#layoutBlockMenu .client-premium-menu__body');
  if (menuBody) menuBody.style.removeProperty('display');

  const page = document.getElementById('clientPage');
  if (page) {
    page.style.removeProperty('--tpl-future-accent');
    page.style.removeProperty('--tpl-future-accent-rgb');
    page.style.removeProperty('--tpl-dynamic-accent');
    page.style.removeProperty('--tpl-dynamic-accent-rgb');
    page.classList.remove(
      'client-dynamic-hero-promo',
      'client-dynamic-hero-campaign',
      'client-dynamic-hero-both'
    );
  }

  const feedbackBtn = document.getElementById('feedbackBtn');
  if (feedbackBtn) feedbackBtn.classList.remove('client-elegant-review--has-stats');
}

/** Gen token — aplicările async vechi nu mai strică tema curentă. */
let _clientTemplateApplyGen = 0;
/** Serializare — un singur apply/restore la un moment dat (fără race la browse Modele). */
let _clientTemplateApplyLock = Promise.resolve();

export function getClientTemplateApplyGen() {
  return _clientTemplateApplyGen;
}

/** Reset hard pe stage / hero / dock — evită layout „totul sus” după browse Modele. */
function hardResetPremiumLayoutShell() {
  const ids = [
    'clientPremiumStage',
    'clientHeroActions',
    'clientPremiumBottomDock',
    'clientPremiumCenterCta',
    'clientPremiumSectionDuo',
    'clientPremiumSectionPromo'
  ];
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    clearTemplateDomInlineStyles(el);
  });
  const page = document.getElementById('clientPage');
  if (page) {
    ['display', 'flex', 'flex-direction', 'justify-content', 'align-items', 'gap', 'height', 'min-height', 'max-height', 'overflow'].forEach(
      (p) => page.style.removeProperty(p)
    );
  }
  try {
    import('./client-connect-template.js?v=83.21')
      .then((m) => {
        m.clearConnectIntruderStyles?.();
        m.hideConnectOnlyChrome?.();
      })
      .catch(() => {});
  } catch (_) {
    /* ignore */
  }
}

async function clearTemplateInlineDomFixes() {
  restoreAllTemplateDomState();
  try {
    await restoreAllClientTemplates();
  } catch (_) {
    /* ignore */
  }
  hardResetPremiumLayoutShell();
  try {
    import('./client-connect-template.js?v=83.21')
      .then((m) => m.clearConnectIntruderStyles?.())
      .catch(() => {});
  } catch (_) {
    /* ignore */
  }
}

function resolveTemplateDomId(normalized, page) {
  if (normalized === 'ai-generated') {
    const variant = String(page?.dataset?.aiTemplateVariant || '').trim().toLowerCase();
    return variant || 'modern';
  }
  return normalized;
}

async function applyRegisteredTemplateDom(normalized, settings = {}) {
  const page = document.getElementById('clientPage');
  const domId = resolveTemplateDomId(normalized, page);
  await applyClientTemplateDom(domId, settings);
}

export function restoreStandardReviewCardMarkup() {
  const head = document.querySelector('#feedbackBtn.client-premium-review-head');
  if (!head) return;

  const stack = document.getElementById('clientElegantReviewStack');
  if (!stack) return;

  const titles = document.createElement('div');
  titles.className = 'client-premium-module-card__titles';

  const feedbackTitle = document.createElement('span');
  feedbackTitle.className = 'feedback-title client-premium-module-card__title';
  feedbackTitle.textContent = 'Recenzie';

  const subtitle = document.createElement('span');
  subtitle.className = 'client-premium-module-card__subtitle';
  subtitle.id = 'clientReviewCardSubtitle';
  subtitle.textContent = 'Lasă-ne părerea ta';

  titles.appendChild(feedbackTitle);
  titles.appendChild(subtitle);
  stack.replaceWith(titles);
}

export function finalizeElegantReviewVisibility(settings = {}) {
  if (!isElegantTemplateActive()) return;

  const feedbackBtn = document.getElementById('feedbackBtn');
  const layoutReview = document.getElementById('layoutBlockReview');
  const reviewShell = document.querySelector('.client-premium-review-shell');
  if (feedbackBtn) {
    feedbackBtn.style.setProperty('display', 'flex', 'important');
  }
  if (reviewShell) {
    reviewShell.classList.remove('client-premium-review-shell--no-feedback');
  }
  if (layoutReview) {
    layoutReview.style.removeProperty('display');
    layoutReview.hidden = false;
    layoutReview.removeAttribute('hidden');
    layoutReview.removeAttribute('aria-hidden');
  }

  ensureElegantReviewCardMarkup();
  syncElegantReviewCard(settings);
}

export function syncCompactReviewCard(settings = {}) {
  if (isElegantTemplateActive()) return;
  if (isConnectTemplateActive()) return;
  if (isAlfaTemplateActive()) return;
  if (isStandardTemplateActive()) return;

  restoreStandardReviewCardMarkup();

  const label =
    String(settings?.feedbackButtonLabel || '').trim() ||
    String(settings?.feedbackCardTitle || '').trim() ||
    'Recenzie';
  const cardTitle = document.querySelector('#feedbackBtn .feedback-title');
  const isDynamic = isDynamicTemplateActive();

  if (cardTitle) {
    cardTitle.textContent = isDynamic ? label : `⭐ ${label}`;
  }

  const icon = document.querySelector(
    '#feedbackBtn .client-premium-module-card__icon--review'
  );
  if (icon) {
    icon.style.removeProperty('display');
    icon.hidden = false;
  }

  const subtitle = document.getElementById('clientReviewCardSubtitle');
  if (subtitle) {
    subtitle.textContent = '';
    subtitle.hidden = true;
    subtitle.style.display = 'none';
  }
}

export function applyElegantTemplateDomFixes() {
  const page = document.getElementById('clientPage');
  if (!isElegantTemplateActive(page)) return;

  const hero = document.getElementById('clientHeroActions');
  if (hero) {
    hero.style.setProperty('display', 'contents', 'important');
    hero.style.setProperty('min-height', '0', 'important');
    hero.style.setProperty('padding-bottom', '0', 'important');
  }

  const socialIconsBar = document.getElementById('socialIconsBar');
  if (socialIconsBar) socialIconsBar.style.setProperty('display', 'none', 'important');

  ['layoutBlockLoyalty', 'layoutBlockEvent', 'layoutBlockRules', 'layoutBlockSocial'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.setProperty('display', 'none', 'important');
  });

  const elegantSocial = document.getElementById('clientElegantSocialSection');
  if (elegantSocial) {
    elegantSocial.hidden = true;
    elegantSocial.setAttribute('hidden', '');
    elegantSocial.setAttribute('aria-hidden', 'true');
    elegantSocial.style.setProperty('display', 'none', 'important');
  }

  const promoTrigger = document.getElementById('clientPromoGalleryTrigger');
  if (promoTrigger) promoTrigger.style.removeProperty('display');

  const menuBody = document.querySelector('.client-premium-card--menu .client-premium-menu__body');
  if (menuBody) menuBody.style.removeProperty('display');

  ensureElegantReviewCardMarkup();
}

function getElegantReviewStats(settings = {}) {
  const ratingRaw =
    settings?.googleRating ??
    settings?.clientReviewRating ??
    settings?.feedbackRating ??
    settings?.reviewRating;
  const countRaw =
    settings?.googleReviewCount ??
    settings?.clientReviewCount ??
    settings?.feedbackReviewCount ??
    settings?.reviewCount;

  const ratingNum = Number(String(ratingRaw ?? '').replace(',', '.').trim());
  const countNum = Number(String(countRaw ?? '').replace(/\D/g, ''));

  return {
    rating: Number.isFinite(ratingNum) && ratingNum > 0 ? ratingNum : null,
    count: Number.isFinite(countNum) && countNum > 0 ? Math.round(countNum) : null
  };
}

function formatElegantReviewRating(rating) {
  const value = Number(rating);
  if (!Number.isFinite(value) || value <= 0) return '';
  return `${value.toFixed(1).replace('.', ',')} / 5`;
}

function formatElegantReviewStarRow(rating) {
  const value = Number(rating);
  if (!Number.isFinite(value) || value <= 0) return '';
  const rounded = Math.max(0, Math.min(5, Math.round(value)));
  return `${'★'.repeat(rounded)}${'☆'.repeat(5 - rounded)}`;
}

function formatElegantReviewCount(count) {
  const value = Number(count);
  if (!Number.isFinite(value) || value <= 0) return '';
  return `${value.toLocaleString('ro-RO')} recenzii`;
}

function getElegantReviewQuotes(settings = {}) {
  const raw = [
    settings?.clientReviewQuote,
    settings?.clientReviewHighlight,
    settings?.feedbackHighlight,
    ...(Array.isArray(settings?.clientReviewQuotes) ? settings.clientReviewQuotes : [])
  ];

  return raw
    .map((entry) => String(entry || '').trim())
    .filter((entry) => entry.length > 0 && entry.length <= 120)
    .slice(0, 2);
}

function formatElegantReviewQuotes(settings = {}) {
  const quotes = getElegantReviewQuotes(settings);
  if (quotes.length === 0) return '';
  if (quotes.length === 1) return `"${quotes[0]}"`;
  return `"${quotes[0]}"\n"${quotes[1]}"`;
}

function getElegantReviewMessage(settings = {}, rating, count) {
  const quoteBlock = formatElegantReviewQuotes(settings);
  if (quoteBlock) return quoteBlock;

  const tagline = String(settings?.clientTagline || '').trim();
  if (tagline && tagline.length <= 100) return `"${tagline}"`;

  const feedbackTitle = String(settings?.feedbackTitle || '').trim();
  const defaultThanks = 'Îți mulțumim pentru vizită!';
  if (feedbackTitle && feedbackTitle !== defaultThanks && feedbackTitle.length <= 100) {
    return `"${feedbackTitle}"`;
  }

  if (count) {
    return `Peste ${Number(count).toLocaleString('ro-RO')} clienți ne-au evaluat.`;
  }

  if (rating) {
    return 'Servire rapidă și produse excelente.';
  }

  return '';
}

function ensureElegantReviewCardMarkup() {
  const head = document.querySelector('#feedbackBtn.client-premium-review-head');
  if (!head) return;

  let stack = document.getElementById('clientElegantReviewStack');
  if (stack) {
    if (!document.getElementById('clientElegantReviewStars')) {
      const starsEl = document.createElement('span');
      starsEl.id = 'clientElegantReviewStars';
      starsEl.className = 'client-elegant-review__stars';
      const countEl = document.getElementById('clientElegantReviewCount');
      if (countEl) {
        stack.insertBefore(starsEl, countEl);
      } else {
        stack.appendChild(starsEl);
      }
    }
    return;
  }

  stack = document.createElement('div');
  stack.id = 'clientElegantReviewStack';
  stack.className = 'client-elegant-review__stack';

  const spec = [
    ['clientElegantReviewTitle', 'client-elegant-review__title', 'span'],
    ['clientElegantReviewHint', 'client-elegant-review__hint', 'span'],
    ['clientElegantReviewRating', 'client-elegant-review__rating', 'span'],
    ['clientElegantReviewStars', 'client-elegant-review__stars', 'span'],
    ['clientElegantReviewCount', 'client-elegant-review__count', 'span'],
    ['clientElegantReviewMessage', 'client-elegant-review__message', 'p']
  ];

  spec.forEach(([id, className, tag]) => {
    const el = document.createElement(tag);
    el.id = id;
    el.className = className;
    stack.appendChild(el);
  });

  const titles = head.querySelector('.client-premium-module-card__titles');
  if (titles) {
    titles.replaceWith(stack);
  } else {
    head.appendChild(stack);
  }
}

export function syncElegantReviewCard(settings = {}) {
  if (!isElegantTemplateActive()) return;

  ensureElegantReviewCardMarkup();

  const titleEl = document.getElementById('clientElegantReviewTitle');
  const hintEl = document.getElementById('clientElegantReviewHint');
  const ratingEl = document.getElementById('clientElegantReviewRating');
  const starsEl = document.getElementById('clientElegantReviewStars');
  const countEl = document.getElementById('clientElegantReviewCount');
  const messageEl = document.getElementById('clientElegantReviewMessage');
  const { rating, count } = getElegantReviewStats(settings);
  const hasStats = !!(rating || count);

  const cardTitleText =
    String(settings?.feedbackButtonLabel || '').trim() ||
    String(settings?.feedbackCardTitle || '').trim() ||
    'Recenzie';
  if (titleEl) titleEl.textContent = cardTitleText;

  if (hintEl) {
    const subtext = String(settings?.feedbackSubtext || '').trim();
    const rawHint = hasStats
      ? 'Vezi ce spun clienții noștri'
      : subtext || 'Apasă pentru a lăsa o recenzie';
    hintEl.textContent = rawHint.length > 72 ? `${rawHint.slice(0, 69)}…` : rawHint;
    hintEl.style.display = '';
    hintEl.hidden = false;
  }

  if (ratingEl) {
    const ratingText = formatElegantReviewRating(rating);
    ratingEl.textContent = ratingText;
    ratingEl.hidden = !ratingText;
    ratingEl.style.display = ratingText ? '' : 'none';
  }

  if (starsEl) {
    const starsText = formatElegantReviewStarRow(rating);
    starsEl.textContent = starsText || (hasStats ? '' : '★★★★★');
    starsEl.hidden = !starsText && hasStats;
    starsEl.style.display = starsText || !hasStats ? '' : 'none';
    if (!hasStats && !starsText) {
      starsEl.style.opacity = '0.45';
      starsEl.style.fontSize = '13px';
    } else {
      starsEl.style.removeProperty('opacity');
      starsEl.style.removeProperty('font-size');
    }
  }

  if (countEl) {
    const countText = formatElegantReviewCount(count);
    countEl.textContent = countText;
    countEl.hidden = !countText;
    countEl.style.display = countText ? '' : 'none';
  }

  if (messageEl) {
    const detail = getElegantReviewMessage(settings, rating, count);
    messageEl.textContent =
      detail ||
      (hasStats ? 'Peste mulți clienți ne-au evaluat pozitiv.' : 'Află părerile clienților');
  }

  const feedbackBtn = document.getElementById('feedbackBtn');
  if (feedbackBtn) {
    feedbackBtn.classList.toggle('client-elegant-review--has-stats', hasStats);
  }

  const reviewIcon = document.querySelector(
    '#feedbackBtn .client-premium-module-card__icon--review'
  );
  if (reviewIcon) {
    reviewIcon.style.display = hasStats ? 'none' : '';
    reviewIcon.hidden = hasStats;
  }
}

export function syncTemplateHeaderBrand(settings = {}) {
  const logoEl = document.getElementById('clientTemplateBrandLogo');
  const logoUrl = sanitizeImageSrc(String(settings?.locationLogoURL || '').trim());
  if (!logoEl) return;
  if (logoUrl) {
    logoEl.src = logoUrl;
    logoEl.hidden = false;
    logoEl.removeAttribute('hidden');
  } else {
    logoEl.removeAttribute('src');
    logoEl.hidden = true;
  }
}

export function syncElegantTopChrome(settings = {}, options = {}) {
  const header = document.getElementById('clientTemplateHeader');
  const socialRow = document.getElementById('clientTemplateSocialRow');
  const top = header?.querySelector('.client-template-header__top');
  if (!header || !top || !socialRow) return;

  if (!isElegantTemplateActive()) {
    header.classList.remove('client-elegant-top-chrome');
    return;
  }

  const joyStep3 = Array.isArray(options.joyStep3Modules) ? options.joyStep3Modules : [];
  const joySocialPicked = joyStep3.filter((id) =>
    ['facebook', 'instagram', 'tiktok'].includes(id)
  );

  syncTemplateHeaderBrand(settings);
  const platforms = getHeaderSocialPlatforms(settings, { joyPicked: joySocialPicked });
  const logoUrl = String(settings?.locationLogoURL || '').trim();
  const showLogo = !!logoUrl || joyStep3.includes('logo');
  const showSocial = platforms.length > 0;

  socialRow.replaceChildren();
  if (showSocial) {
    platforms.forEach((platform) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `client-template-header__social-btn client-template-header__social-btn--${platform.key}`;
      btn.setAttribute('data-action', 'openExternalAction');
      btn.setAttribute('data-arg', platform.arg);
      btn.setAttribute('aria-label', platform.label);
      btn.innerHTML = CLIENT_HEADER_SOCIAL_SVGS[platform.key] || '';
      socialRow.appendChild(btn);
    });
    socialRow.hidden = false;
    socialRow.removeAttribute('hidden');
    socialRow.removeAttribute('aria-hidden');
  } else {
    socialRow.hidden = true;
    socialRow.setAttribute('aria-hidden', 'true');
  }

  const logoEl = document.getElementById('clientTemplateBrandLogo');
  if (logoEl && showLogo && !logoUrl) {
    logoEl.removeAttribute('src');
    logoEl.hidden = false;
    logoEl.removeAttribute('hidden');
    logoEl.classList.add('client-elegant-top-chrome__logo-ph');
    logoEl.setAttribute('aria-label', 'Logo');
  } else if (logoEl) {
    logoEl.classList.remove('client-elegant-top-chrome__logo-ph');
  }

  const showChrome = showLogo || showSocial;
  if (showChrome) {
    header.classList.add('client-elegant-top-chrome');
    header.hidden = false;
    header.removeAttribute('hidden');
    header.removeAttribute('aria-hidden');
    header.style.setProperty('display', 'flex', 'important');
    header.style.setProperty('position', 'fixed', 'important');
    header.style.setProperty('visibility', 'visible', 'important');
    header.style.setProperty('height', 'auto', 'important');
    header.style.setProperty('overflow', 'visible', 'important');
    header.style.setProperty('pointer-events', 'none', 'important');
  } else {
    header.classList.remove('client-elegant-top-chrome');
    header.hidden = true;
    header.setAttribute('aria-hidden', 'true');
  }
}

export function syncElegantSocialCard(settings = {}) {
  const section = document.getElementById('clientElegantSocialSection');
  const row = document.getElementById('clientElegantSocialRow');
  if (!section || !row) return;

  section.hidden = true;
  section.setAttribute('hidden', '');
  section.setAttribute('aria-hidden', 'true');
  section.style.setProperty('display', 'none', 'important');
  row.replaceChildren();
}

export function syncElegantClientCopy(settings = {}) {
  if (!isElegantTemplateActive()) return;

  syncElegantSocialCard(settings);

  const menuSub = document.getElementById('clientMenuCardSubtitle');
  if (menuSub) {
    menuSub.textContent =
      String(settings?.menuDescription || '').trim() || 'Vezi detalii';
  }

  const campaignSub = document.getElementById('clientCampaignSubtitle');
  if (campaignSub) {
    campaignSub.textContent =
      String(settings?.claimMessage || '').trim() || 'Joacă și câștigă premii!';
  }

  syncElegantReviewCard(settings);
}

export function applyClientTemplateToPage(style, options = {}) {
  const gen = ++_clientTemplateApplyGen;
  const job = async () => {
    if (gen !== _clientTemplateApplyGen) {
      return normalizeClientTemplateStyle(style);
    }

    const page = document.getElementById('clientPage');
    if (!page) return DEFAULT_CLIENT_TEMPLATE_STYLE;

    const rawStyle0 = String(style || '').trim().toLowerCase();
    const rawStyle = RETIRED_TEMPLATE_MAP[rawStyle0] || rawStyle0;

    if (rawStyle === 'standard') {
      CLIENT_TEMPLATE_STYLES.forEach((id) => page.classList.remove(`template-${id}`));
      page.classList.remove(...STANDARD_TEMPLATE_CLASS_MARKERS, 'template-standard', 'template-ai-generated');
      delete page.dataset.aiTemplateVariant;
      await clearTemplateInlineDomFixes();
      if (gen !== _clientTemplateApplyGen) return 'standard';
      page.classList.add('template-standard');
      applyStandardTemplateDomFixes(options?.settings || {});
      await applyRegisteredTemplateDom('standard', options?.settings || {});
      return 'standard';
    }

    const normalized = normalizeClientTemplateStyle(style);
    const aiVariant = options?.aiVariant ? normalizeClientTemplateStyle(options.aiVariant) : null;

    await clearTemplateInlineDomFixes();
    if (gen !== _clientTemplateApplyGen) return normalized;

    CLIENT_TEMPLATE_STYLES.forEach((id) => page.classList.remove(`template-${id}`));
    page.classList.remove(
      'template-elegant',
      'template-modern',
      'template-dynamic',
      'template-future',
      'template-minimal',
      'template-connect',
      'template-alfa',
      'template-custom',
      'template-avva',
      'template-afis',
      'template-tabla',
      'template-glass',
      'template-standard',
      'template-ai-generated',
      // variantele Cloud rămâneau pe pagină la trecerea Rimga/Cloud Luminos → Universal Soft/Custom
      'template-cloud',
      'template-cloud-light',
      'template-cloud-rimga'
    );

    if (normalized === 'ai-generated') {
      const base = CLIENT_TEMPLATE_FIXED.includes(aiVariant) ? aiVariant : pickRandomTemplateVariant();
      page.classList.add(`template-${base}`, 'template-ai-generated');
      page.dataset.aiTemplateVariant = base;
    } else if (normalized === 'cloud' || normalized === 'cloud-light' || normalized === 'rimga') {
      // Cloud = structura Custom + strat vizual propriu; Cloud Luminos / Rimga = variante peste Cloud
      page.classList.remove('template-cloud-light', 'template-cloud-rimga');
      page.classList.add('template-custom', 'template-cloud');
      if (normalized === 'cloud-light') page.classList.add('template-cloud-light');
      if (normalized === 'rimga') page.classList.add('template-cloud-rimga');
      delete page.dataset.aiTemplateVariant;
    } else {
      page.classList.add(`template-${normalized}`);
      delete page.dataset.aiTemplateVariant;
    }

    // culoarea aleasă (bulina) se aplică la orice temă
    {
      const acc = String((options?.settings || {}).customTemplateAccent || '').trim().toLowerCase();
      if (['rose', 'blue', 'emerald', 'silver', 'purple', 'orange'].includes(acc)) page.dataset.accent = acc;
      else if (options?.settings && Object.keys(options.settings).length) delete page.dataset.accent;
    }

    if (normalized === 'cloud' || normalized === 'cloud-light' || normalized === 'rimga') {
      await applyRegisteredTemplateDom('custom', options?.settings || {});
      await applyRegisteredTemplateDom('cloud', options?.settings || {});
    } else if (normalized !== 'standard') {
      await applyRegisteredTemplateDom(normalized, options?.settings || {});
    }

    if (gen !== _clientTemplateApplyGen) return normalized;
    return normalized;
  };

  // Pagina se arată abia după ce tema e aplicată (fără „flash” cu interfața veche); și la eroare.
  const markReady = () => {
    try { document.getElementById('clientPage')?.classList.add('sj-tpl-ready'); } catch (_) { /* ignore */ }
  };
  const jobReady = () => Promise.resolve().then(job).finally(markReady);
  const result = _clientTemplateApplyLock.then(jobReady, jobReady);
  _clientTemplateApplyLock = result.then(
    () => undefined,
    () => undefined
  );
  return result;
}

/** Preview „Standard” — clasă template-standard + layout baseline premium. */
export async function restoreAiPreviewToStandardVisual(settings = {}) {
  const page = document.getElementById('clientPage');
  if (!page) return;

  await clearTemplateInlineDomFixes();

  CLIENT_TEMPLATE_STYLES.forEach((id) => page.classList.remove(`template-${id}`));
  page.classList.remove(...STANDARD_TEMPLATE_CLASS_MARKERS, 'template-standard');
  delete page.dataset.aiTemplateVariant;
  page.style.removeProperty('--tpl-dynamic-accent');
  page.style.removeProperty('--tpl-dynamic-accent-rgb');
  page.style.removeProperty('--tpl-future-accent');
  page.style.removeProperty('--tpl-future-accent-rgb');
  page.classList.remove(
    'client-dynamic-hero-promo',
    'client-dynamic-hero-campaign',
    'client-dynamic-hero-both'
  );

  page.classList.add('template-standard');

  applyStandardTemplateDomFixes(settings);
  await applyRegisteredTemplateDom('standard', settings);
}

export function applyModernTemplateDomFixes() {
  const page = document.getElementById('clientPage');
  if (!isModernTemplateActive(page)) return;

  syncCompactReviewCard();

  const hero = document.getElementById('clientHeroActions');
  if (hero) {
    hero.style.setProperty('display', 'contents', 'important');
    hero.style.setProperty('flex', '0 0 auto', 'important');
    hero.style.setProperty('min-height', '0', 'important');
    hero.style.setProperty('padding-bottom', '0', 'important');
  }

  ['layoutBlockLoyalty', 'layoutBlockEvent', 'layoutBlockRules', 'layoutBlockSocial'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.setProperty('display', 'none', 'important');
  });

  const socialIconsBar = document.getElementById('socialIconsBar');
  if (socialIconsBar) socialIconsBar.style.setProperty('display', 'none', 'important');
}

export function applyDynamicTemplateDomFixes() {
  const page = document.getElementById('clientPage');
  if (!isDynamicTemplateActive(page)) return;

  syncCompactReviewCard();

  const hero = document.getElementById('clientHeroActions');
  if (hero) {
    hero.style.setProperty('display', 'contents', 'important');
    hero.style.setProperty('flex', '0 0 auto', 'important');
    hero.style.setProperty('min-height', '0', 'important');
    hero.style.setProperty('padding-bottom', '0', 'important');
  }

  ['layoutBlockLoyalty', 'layoutBlockEvent', 'layoutBlockRules', 'layoutBlockSocial'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.setProperty('display', 'none', 'important');
  });

  const socialIconsBar = document.getElementById('socialIconsBar');
  if (socialIconsBar) socialIconsBar.style.setProperty('display', 'none', 'important');

  const promoTrigger = document.getElementById('clientPromoGalleryTrigger');
  if (promoTrigger) promoTrigger.style.removeProperty('display');

  restoreDynamicPromoDomStructure();
  clearDynamicPromoPreview();
}

export function applyFutureTemplateDomFixes() {
  const page = document.getElementById('clientPage');
  if (!isFutureTemplateActive(page)) return;

  syncCompactReviewCard();

  const header = document.getElementById('clientTemplateHeader');
  if (header) {
    header.hidden = false;
    header.removeAttribute('hidden');
    header.removeAttribute('aria-hidden');
  }

  const hero = document.getElementById('clientHeroActions');
  if (hero) {
    hero.style.setProperty('display', 'contents', 'important');
    hero.style.setProperty('flex', '0 0 auto', 'important');
    hero.style.setProperty('min-height', '0', 'important');
    hero.style.setProperty('padding-bottom', '0', 'important');
  }

  const centerCta = document.getElementById('clientPremiumCenterCta');
  if (centerCta) {
    centerCta.style.setProperty('display', 'flex', 'important');
    centerCta.style.setProperty('position', 'relative', 'important');
    centerCta.style.removeProperty('bottom');
    centerCta.style.removeProperty('left');
    centerCta.style.removeProperty('right');
  }

  const dock = document.getElementById('clientPremiumBottomDock');
  if (dock) {
    dock.style.setProperty('position', 'relative', 'important');
    dock.style.removeProperty('bottom');
    dock.style.removeProperty('left');
    dock.style.removeProperty('right');
  }

  ['layoutBlockEvent', 'layoutBlockRules', 'layoutBlockSocial'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.setProperty('display', 'none', 'important');
  });

  const socialIconsBar = document.getElementById('socialIconsBar');
  if (socialIconsBar) socialIconsBar.style.setProperty('display', 'none', 'important');

  const promoTrigger = document.getElementById('clientPromoGalleryTrigger');
  if (promoTrigger) promoTrigger.style.removeProperty('display');

  restoreDynamicPromoDomStructure();
  clearDynamicPromoPreview();
  ensureFuturePromoStandalone();
  ensureFutureHeaderSocialCol();
  ensureFutureHeroSpacer();
}

export async function syncFutureTemplateAccent(settings = {}) {
  const page = document.getElementById('clientPage');
  if (!isFutureTemplateActive(page)) return;

  let accent = String(settings?.campaignButtonColor || '').trim() || '#22c55e';
  const bgUrl = String(settings?.backgroundImageUrl || settings?.slideshowImage1 || '').trim();
  if (bgUrl) {
    const bgAccent = await sampleImageAccent(bgUrl);
    if (bgAccent) accent = bgAccent;
  }

  const rgb = hexToRgbString(accent);
  if (accent) page.style.setProperty('--tpl-future-accent', accent);
  if (rgb) page.style.setProperty('--tpl-future-accent-rgb', rgb);
}

export function syncFutureClientCopy(settings = {}) {
  if (!isFutureTemplateActive()) return;

  syncTemplateHeaderBrand(settings);

  const menuSub = document.getElementById('clientMenuCardSubtitle');
  if (menuSub) {
    menuSub.textContent = '';
    menuSub.hidden = true;
    menuSub.setAttribute('hidden', '');
  }

  const reviewSub = document.getElementById('clientReviewCardSubtitle');
  if (reviewSub) {
    reviewSub.textContent = '';
    reviewSub.hidden = true;
    reviewSub.setAttribute('hidden', '');
  }

  const campaignSub = document.getElementById('clientCampaignSubtitle');
  if (campaignSub) {
    campaignSub.textContent = '';
    campaignSub.hidden = true;
    campaignSub.setAttribute('hidden', '');
  }

  const ctaLabel = document.querySelector('#playBtn .client-premium-cta__label');
  if (ctaLabel) {
    ctaLabel.textContent =
      String(settings?.playButtonLabel || '').trim() || 'Participă în campanie!';
  }

  const promoSub = document.querySelector(
    '#clientPromoGalleryTrigger .client-premium-banner__subtitle'
  );
  if (promoSub) {
    promoSub.textContent = '';
    promoSub.hidden = true;
    promoSub.setAttribute('hidden', '');
  }

  const promoTitle = document.getElementById('clientPromoGalleryTriggerLabel');
  if (promoTitle) {
    const g = settings?.clientPromoGallery;
    const title = String(g?.title || '').trim() || 'Ofertele săptămânii!';
    promoTitle.textContent = title;
  }

  syncFutureSocialStrip(settings);
  restoreDynamicPromoDomStructure();
  clearDynamicPromoPreview();
}

export function applyMinimalTemplateDomFixes() {
  const page = document.getElementById('clientPage');
  if (!isMinimalTemplateActive(page)) return;

  const header = document.getElementById('clientTemplateHeader');
  if (header) {
    header.hidden = true;
    header.setAttribute('aria-hidden', 'true');
  }
  const sloganEl = document.getElementById('clientTemplateSlogan');
  if (sloganEl) {
    sloganEl.textContent = '';
    sloganEl.hidden = true;
    sloganEl.setAttribute('hidden', '');
  }

  syncCompactReviewCard();

  const hero = document.getElementById('clientHeroActions');
  if (hero) {
    hero.style.setProperty('display', 'contents', 'important');
    hero.style.setProperty('flex', '0 0 auto', 'important');
    hero.style.setProperty('min-height', '0', 'important');
    hero.style.setProperty('padding-bottom', '0', 'important');
  }

  ['layoutBlockLoyalty', 'layoutBlockEvent', 'layoutBlockRules', 'layoutBlockSocial'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.setProperty('display', 'none', 'important');
  });

  const promoTrigger = document.getElementById('clientPromoGalleryTrigger');
  if (promoTrigger) promoTrigger.style.removeProperty('display');
}

export function syncMinimalOffersCard(settings = {}) {
  if (!isMinimalTemplateActive()) return;
  if (isConnectTemplateActive() || isAlfaTemplateActive() || isCustomTemplateActive()) return;

  const wrap = document.getElementById('layoutBlockPromo');
  const trigger = document.getElementById('clientPromoGalleryTrigger');
  const label = document.getElementById('clientPromoGalleryTriggerLabel');
  if (!wrap || !trigger || !label) return;

  const g = settings?.clientPromoGallery;
  const enabled = g?.enabled === true;
  const title = String(g?.title || '').trim();

  if (enabled && title) {
    label.textContent = title;
    wrap.style.display = 'block';
    wrap.removeAttribute('aria-hidden');
    trigger.style.display = 'flex';
  } else if (!enabled) {
    wrap.style.setProperty('display', 'none', 'important');
    wrap.setAttribute('aria-hidden', 'true');
    trigger.style.setProperty('display', 'none', 'important');
    label.textContent = '';
  }
}

/** Essentials: numele localului sus, deasupra butoanelor rapide (tema nu are antetul comun). */
function syncMinimalBrand(settings = {}, page = document.getElementById('clientPage')) {
  const existing = document.getElementById('sjMinimalBrand');
  if (!page || !isMinimalTemplateActive(page)) {
    existing?.remove();
    return;
  }
  const name = String(settings?.locationMapName || settings?.companyName || '').trim();
  if (!name) {
    existing?.remove();
    return;
  }
  const el = existing || document.createElement('h1');
  el.id = 'sjMinimalBrand';
  el.className = 'sj-minimal-brand';
  el.textContent = name;
  if (!existing) {
    const dock = document.getElementById('clientPremiumBottomDock');
    if (dock && dock.parentElement === page) page.insertBefore(el, dock);
    else page.insertBefore(el, page.firstChild);
  }
}

export function syncMinimalClientCopy(settings = {}) {
  if (!isMinimalTemplateActive()) return;

  const campaignSub = document.getElementById('clientCampaignSubtitle');
  if (campaignSub) {
    campaignSub.textContent = '';
  }
}

export function pickRandomTemplateVariant(exclude) {
  const pool = CLIENT_TEMPLATE_FIXED.filter((id) => id !== exclude);
  return pool[Math.floor(Math.random() * pool.length)] || CLIENT_TEMPLATE_FIXED[0];
}

export function getHeaderSocialPlatforms(settings = {}, options = {}) {
  const joyPicked = new Set(options.joyPicked || []);
  const sm = settings.socialMedia || {};
  const platforms = [
    { key: 'instagram', arg: 'instagram', label: 'Instagram', fallback: settings.clientInstagramUrl },
    { key: 'facebook', arg: 'facebook', label: 'Facebook', fallback: settings.clientSocialUrl },
    { key: 'tiktok', arg: 'tiktok', label: 'TikTok', fallback: settings.clientTiktokUrl }
  ];

  return platforms.filter((platform) => {
    if (joyPicked.has(platform.key)) return true;
    const entry = sm[platform.key] || {};
    const link = String(entry.link || platform.fallback || '').trim();
    if (!link) return false;
    if (Object.prototype.hasOwnProperty.call(sm, platform.key) && entry.enabled === false) {
      return false;
    }
    return true;
  });
}

/** Avva: înălțimea ferestrei hero = distanța până la foaia crem (pozele nu sunt mascate). */
let _avvaHeroRo = null;
let _avvaHeroRaf = 0;
let _avvaHeroOnResize = null;

export function syncAvvaHeroFrame() {
  const page = document.getElementById('clientPage');
  const root = document.documentElement;
  if (!page?.classList.contains('template-avva') || !page.classList.contains('visible')) {
    root.style.removeProperty('--avva-hero-h');
    return;
  }
  const sheetTop =
    page.querySelector('.client-template-header:not([hidden])') ||
    page.querySelector('#clientPremiumSectionPromo') ||
    page.querySelector('#clientPremiumCenterCta') ||
    page.querySelector('#clientPremiumSectionDuo');
  if (!sheetTop) return;
  const rect = sheetTop.getBoundingClientRect();
  /* Lipire exactă: hero până la marginea de sus a foii crem (fără gap) */
  const h = Math.max(120, Math.round(rect.top));
  root.style.setProperty('--avva-hero-h', `${h}px`);
}

function scheduleAvvaHeroFrame() {
  cancelAnimationFrame(_avvaHeroRaf);
  _avvaHeroRaf = requestAnimationFrame(() => {
    syncAvvaHeroFrame();
    // Al doilea frame — după layout CTA / fonturi
    requestAnimationFrame(syncAvvaHeroFrame);
  });
}

function ensureAvvaHeroObserver() {
  const page = document.getElementById('clientPage');
  if (!page) return;
  if (!_avvaHeroRo && typeof ResizeObserver !== 'undefined') {
    _avvaHeroRo = new ResizeObserver(() => scheduleAvvaHeroFrame());
    _avvaHeroRo.observe(page);
  }
  if (!_avvaHeroOnResize) {
    _avvaHeroOnResize = () => scheduleAvvaHeroFrame();
    window.addEventListener('resize', _avvaHeroOnResize, { passive: true });
    window.addEventListener('orientationchange', _avvaHeroOnResize, { passive: true });
  }
  scheduleAvvaHeroFrame();
}

function teardownAvvaHeroFrame() {
  cancelAnimationFrame(_avvaHeroRaf);
  _avvaHeroRaf = 0;
  if (_avvaHeroRo) {
    try {
      _avvaHeroRo.disconnect();
    } catch (_) {
      /* ignore */
    }
    _avvaHeroRo = null;
  }
  if (_avvaHeroOnResize) {
    window.removeEventListener('resize', _avvaHeroOnResize);
    window.removeEventListener('orientationchange', _avvaHeroOnResize);
    _avvaHeroOnResize = null;
  }
  document.documentElement.style.removeProperty('--avva-hero-h');
}

/** Avva: mereu FB / IG / TikTok în header (dreapta), chiar dacă lipsește link-ul. */
export function syncAvvaHeader(settings = {}) {
  const header = document.getElementById('clientTemplateHeader');
  const socialRow = document.getElementById('clientTemplateSocialRow');
  const brandEl = document.getElementById('clientTemplateBrand');
  const sloganEl = document.getElementById('clientTemplateSlogan');
  if (!header || !socialRow) return;

  const s = settings || getCurrentSettings() || {};
  syncTemplateHeaderBrand(s);

  // pe pagină: denumirea comercială (ex. „Anturaj”), nu SRL-ul; fără ea, numele firmei
  const company = String(s.locationMapName || '').trim() || String(s.companyName || '').trim();
  if (brandEl) {
    brandEl.textContent = company;
    brandEl.hidden = !company;
    if (company) brandEl.removeAttribute('hidden');
  }

  if (sloganEl) {
    sloganEl.textContent = '';
    sloganEl.hidden = true;
    sloganEl.setAttribute('hidden', '');
    sloganEl.setAttribute('aria-hidden', 'true');
  }

  const configured = new Set(getHeaderSocialPlatforms(s).map((p) => p.key));
  const all = [
    { key: 'facebook', arg: 'facebook', label: 'Facebook' },
    { key: 'instagram', arg: 'instagram', label: 'Instagram' },
    { key: 'tiktok', arg: 'tiktok', label: 'TikTok' }
  ];

  socialRow.replaceChildren();
  all.forEach((platform) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `client-template-header__social-btn client-template-header__social-btn--${platform.key}`;
    btn.setAttribute('data-action', 'openExternalAction');
    btn.setAttribute('data-arg', platform.arg);
    btn.setAttribute('aria-label', platform.label);
    if (!configured.has(platform.key)) btn.classList.add('is-muted');
    btn.innerHTML = CLIENT_HEADER_SOCIAL_SVGS[platform.key] || '';
    socialRow.appendChild(btn);
  });

  socialRow.hidden = false;
  socialRow.removeAttribute('hidden');
  socialRow.removeAttribute('aria-hidden');
  socialRow.style.setProperty('display', 'flex', 'important');

  header.hidden = false;
  header.removeAttribute('hidden');
  header.removeAttribute('aria-hidden');
  header.style.setProperty('display', 'flex', 'important');
}

export function syncClientTemplateHeader(settings = {}) {
  const header = document.getElementById('clientTemplateHeader');
  if (!header) return;

  const page = document.getElementById('clientPage');
  const isElegant = isElegantTemplateActive(page);
  const isModern = isModernTemplateActive(page);
  const isDynamic = isDynamicTemplateActive(page);
  const isFuture = isFutureTemplateActive(page);
  const isConnect = isConnectTemplateActive(page);
  const isAlfa = isAlfaTemplateActive(page);
  const isCustom = isCustomTemplateActive(page);
  const isAvva = isAvvaTemplateActive(page);
  const isPoster = isPosterTemplateActive(page); // Afiș / Tablă / Glass
  const showHeader = isElegant || isModern || isDynamic || isFuture || isConnect || isAlfa || isCustom || isAvva || isPoster;
  const company = String(settings?.locationMapName || '').trim() || String(settings?.companyName || '').trim();
  const headerPlatforms = getHeaderSocialPlatforms(settings);
  const slogan =
    String(settings?.clientTagline || '').trim() ||
    String(settings?.socialCardHint || '').trim() ||
    'Urmărește-ne';
  const brandEl = document.getElementById('clientTemplateBrand');
  const sloganEl = document.getElementById('clientTemplateSlogan');
  const socialRow = document.getElementById('clientTemplateSocialRow');

  const hideHeaderSlogan = () => {
    if (!sloganEl) return;
    sloganEl.textContent = '';
    sloganEl.hidden = true;
    sloganEl.setAttribute('hidden', '');
    sloganEl.setAttribute('aria-hidden', 'true');
  };

  syncMinimalBrand(settings, page);

  if (!showHeader) {
    header.hidden = true;
    header.setAttribute('aria-hidden', 'true');
    hideHeaderSlogan();
    return;
  }

  if (isElegant) {
    syncElegantTopChrome(settings);
    syncElegantSocialCard(settings);
    applyElegantTemplateDomFixes();
    syncElegantClientCopy(settings);
    finalizeElegantReviewVisibility(settings);
    return;
  }

  if (isConnect) {
    import('./client-connect-template.js?v=83.21')
      .then((m) => {
        m.applyConnectTemplateDomFixes?.();
        m.syncConnectClientCopy?.(settings);
      })
      .catch(() => {});
    return;
  }

  if (isAlfa) {
    import('./client-alfa-template.js?v=83.21')
      .then((m) => {
        m.applyAlfaTemplateDomFixes?.();
        m.syncAlfaClientCopy?.(settings);
        m.finalizeAlfaDuoChrome?.(settings);
      })
      .catch(() => {});
    return;
  }

  if (isCustom) {
    import('./client-custom-template.js?v=83.21')
      .then((m) => {
        m.applyCustomTemplateDomFixes?.();
        m.syncCustomClientCopy?.(settings);
      })
      .catch(() => {});
    if (page?.classList?.contains('template-cloud')) {
      import('./client-cloud-template.js?v=83.21')
        .then((m) => m.applyCloudTemplateDom?.(settings))
        .catch(() => {});
    }
    return;
  }

  if (isAvva) {
    syncAvvaHeader(settings);
    return;
  }

  if (isPoster) {
    import('./client-afis-template.js?v=83.21')
      .then((m) => m.syncAfisTemplate?.(settings))
      .catch(() => {});
    return;
  }

  if (!company) {
    header.hidden = true;
    header.setAttribute('aria-hidden', 'true');
    return;
  }

  syncTemplateHeaderBrand(settings);

  if (brandEl) {
    brandEl.textContent = company;
    brandEl.hidden = false;
    brandEl.removeAttribute('hidden');
  }

  if (sloganEl) {
    if (isModern || isDynamic) {
      hideHeaderSlogan();
    } else if (isFuture) {
      sloganEl.textContent = '';
      sloganEl.hidden = true;
      sloganEl.setAttribute('hidden', '');
    } else {
      sloganEl.textContent = slogan;
      sloganEl.hidden = true;
      sloganEl.setAttribute('hidden', '');
    }
  }

  if (socialRow) {
    socialRow.replaceChildren();
    const platforms = headerPlatforms;
    if (isFuture) {
      /* populat în syncFutureSocialStrip */
    } else if (isDynamic) {
      if (platforms.length === 0) {
        socialRow.hidden = true;
        socialRow.setAttribute('aria-hidden', 'true');
      } else {
        socialRow.hidden = false;
        socialRow.removeAttribute('aria-hidden');
        platforms.forEach((platform, index) => {
          if (index > 0) {
            const sep = document.createElement('span');
            sep.className = 'client-template-header__social-sep';
            sep.textContent = '•';
            sep.setAttribute('aria-hidden', 'true');
            socialRow.appendChild(sep);
          }
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = `client-template-header__social-link client-template-header__social-link--${platform.key}`;
          btn.setAttribute('data-action', 'openExternalAction');
          btn.setAttribute('data-arg', platform.arg);
          btn.setAttribute('aria-label', platform.label);
          btn.textContent = platform.label;
          socialRow.appendChild(btn);
        });
      }
    } else if (platforms.length === 0) {
      socialRow.hidden = true;
      socialRow.setAttribute('aria-hidden', 'true');
    } else {
      socialRow.hidden = false;
      socialRow.removeAttribute('aria-hidden');
      platforms.forEach((platform) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `client-template-header__social-btn client-template-header__social-btn--${platform.key}`;
        btn.setAttribute('data-action', 'openExternalAction');
        btn.setAttribute('data-arg', platform.arg);
        btn.setAttribute('aria-label', platform.label);
        btn.innerHTML = CLIENT_HEADER_SOCIAL_SVGS[platform.key] || '';
        socialRow.appendChild(btn);
      });
    }
  }

  header.hidden = false;
  header.removeAttribute('aria-hidden');

  applyDynamicHeaderOrder(isDynamic);
  syncDynamicHeaderEditable(settings);

  if (isModern) {
    applyModernTemplateDomFixes();
  } else if (isDynamic) {
    applyDynamicTemplateDomFixes();
    syncDynamicClientCopy(settings);
    syncDynamicTemplateAccent(settings);
  } else if (isFuture) {
    applyFutureTemplateDomFixes();
    syncFutureClientCopy(settings);
    syncFutureTemplateAccent(settings);
    syncFutureSocialStrip(settings);
  }
}

registerClientTemplate('elegant', {
  apply: () => applyElegantTemplateDomFixes(),
  restore: () => {}
});

registerClientTemplate('modern', {
  apply: () => applyModernTemplateDomFixes(),
  restore: () => {}
});

registerClientTemplate('dynamic', {
  apply: () => applyDynamicTemplateDomFixes(),
  restore: () => {}
});

registerClientTemplate('future', {
  apply: () => applyFutureTemplateDomFixes(),
  restore: () => {}
});

registerClientTemplate('minimal', {
  apply: () => applyMinimalTemplateDomFixes(),
  restore: () => {}
});

registerClientTemplate('connect', {
  apply: () =>
    import('./client-connect-template.js?v=83.21')
      .then((m) => m.applyConnectTemplateDomFixes?.())
      .catch(() => {}),
  restore: () =>
    import('./client-connect-template.js?v=83.21')
      .then((m) => m.restoreConnectTemplateDom?.())
      .catch(() => {})
});

registerClientTemplate('alfa', {
  apply: () =>
    import('./client-alfa-template.js?v=83.21')
      .then((m) => m.applyAlfaTemplateDomFixes?.())
      .catch(() => {}),
  restore: () =>
    import('./client-alfa-template.js?v=83.21')
      .then((m) => m.restoreAlfaTemplateDom?.())
      .catch(() => {})
});

registerClientTemplate('custom', {
  apply: () =>
    import('./client-custom-template.js?v=83.21')
      .then((m) => m.applyCustomTemplateDomFixes?.())
      .catch(() => {}),
  restore: () =>
    import('./client-custom-template.js?v=83.21')
      .then((m) => m.restoreCustomTemplateDom?.())
      .catch(() => {})
});

registerClientTemplate('cloud', {
  apply: (settings = {}) =>
    import('./client-cloud-template.js?v=83.21')
      .then((m) => m.applyCloudTemplateDom?.(settings))
      .catch(() => {}),
  restore: () =>
    import('./client-cloud-template.js?v=83.21')
      .then((m) => m.restoreCloudTemplateDom?.())
      .catch(() => {})
});

/* Avva — temă light premium (nume stânga · social dreapta · sheet pe conținut). */
registerClientTemplate('avva', {
  apply: (settings = {}) => {
    if (!isAvvaTemplateActive()) return;

    const playBtn = document.getElementById('playBtn');
    if (playBtn) {
      playBtn.style.removeProperty('background');
      playBtn.style.removeProperty('background-color');
      playBtn.style.removeProperty('background-image');
    }
    document.getElementById('clientPage')?.style.removeProperty('--campaign-btn-bg');

    const stage = document.getElementById('clientPremiumStage');
    if (stage) {
      stage.style.setProperty('display', 'contents', 'important');
      stage.style.setProperty('flex', '0 0 auto', 'important');
      stage.style.setProperty('min-height', '0', 'important');
    }

    const hero = document.getElementById('clientHeroActions');
    if (hero) {
      hero.style.setProperty('display', 'contents', 'important');
      hero.style.setProperty('flex', '0 0 auto', 'important');
      hero.style.setProperty('min-height', '0', 'important');
      hero.style.setProperty('padding-bottom', '0', 'important');
      hero.style.setProperty('gap', '0', 'important');
    }

    const dock = document.getElementById('clientPremiumBottomDock');
    if (dock) {
      dock.style.removeProperty('display');
      dock.style.removeProperty('position');
      dock.style.removeProperty('bottom');
      dock.style.removeProperty('left');
      dock.style.removeProperty('right');
      dock.style.removeProperty('top');
    }

    ['layoutBlockLoyalty', 'layoutBlockEvent', 'layoutBlockRules', 'layoutBlockSocial'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.setProperty('display', 'none', 'important');
    });

    const elegantSocial = document.getElementById('clientElegantSocialSection');
    if (elegantSocial) {
      elegantSocial.hidden = true;
      elegantSocial.setAttribute('hidden', '');
      elegantSocial.setAttribute('aria-hidden', 'true');
      elegantSocial.style.setProperty('display', 'none', 'important');
    }

    syncAvvaHeader(settings || getCurrentSettings() || {});
    ensureAvvaHeroObserver();
    try {
      import('./loyalty-module.js?v=83.21')
        .then((m) => {
          if (!isAvvaTemplateActive()) return;
          m.updateClientPrimaryActionSlots?.(settings || getCurrentSettings() || {});
          scheduleAvvaHeroFrame();
        })
        .catch(() => {});
    } catch (_) {
      /* ignore */
    }
  },
  restore: () => {
    teardownAvvaHeroFrame();
    const header = document.getElementById('clientTemplateHeader');
    header?.style.removeProperty('display');
    const socialRow = document.getElementById('clientTemplateSocialRow');
    socialRow?.style.removeProperty('display');
    const stage = document.getElementById('clientPremiumStage');
    stage?.style.removeProperty('display');
    stage?.style.removeProperty('flex');
    stage?.style.removeProperty('min-height');
    const hero = document.getElementById('clientHeroActions');
    hero?.style.removeProperty('display');
    hero?.style.removeProperty('flex');
    hero?.style.removeProperty('min-height');
    hero?.style.removeProperty('padding-bottom');
    hero?.style.removeProperty('gap');
    const dock = document.getElementById('clientPremiumBottomDock');
    dock?.style.removeProperty('display');
    dock?.style.removeProperty('position');
  }
});

/* Afiș — poster: hârtie, contur de cerneală, umbre dure (blocuri standard + oferte cu poze). */
registerClientTemplate('afis', {
  apply: (settings = {}) =>
    import('./client-afis-template.js?v=83.21')
      .then((m) => m.applyAfisTemplateDom?.(settings))
      .catch(() => {}),
  restore: () =>
    import('./client-afis-template.js?v=83.21')
      .then((m) => m.restoreAfisTemplateDom?.())
      .catch(() => {})
});

/* Tablă — tablă de cretă: aceleași blocuri ca Afiș (modul comun), CSS în client-tabla.css. */
registerClientTemplate('tabla', {
  apply: (settings = {}) =>
    import('./client-afis-template.js?v=83.21')
      .then((m) => m.applyAfisTemplateDom?.(settings))
      .catch(() => {}),
  restore: () =>
    import('./client-afis-template.js?v=83.21')
      .then((m) => m.restoreAfisTemplateDom?.())
      .catch(() => {})
});

/* Glass — sticlă lichidă: aceleași blocuri ca Afiș (modul comun), CSS în client-glass.css. */
registerClientTemplate('glass', {
  apply: (settings = {}) =>
    import('./client-afis-template.js?v=83.21')
      .then((m) => m.applyAfisTemplateDom?.(settings))
      .catch(() => {}),
  restore: () =>
    import('./client-afis-template.js?v=83.21')
      .then((m) => m.restoreAfisTemplateDom?.())
      .catch(() => {})
});

registerClientTemplate('standard', {
  apply: (settings = {}) =>
    import('./client-standard-template.js?v=83.21')
      .then((m) => m.applyStandardTemplateEnhancements?.(settings))
      .catch(() => {}),
  restore: () =>
    import('./client-standard-template.js?v=83.21')
      .then((m) => m.restoreStandardTemplateDom?.())
      .catch(() => {})
});
